import React from 'react';

import background from "./assets/images/Background.jpg";
import logoCliente from "./assets/images/Logo_Cliente.png";
import iconSoundON from "./assets/images/Button_sound.png";
import iconSoundOff from "./assets/images/Button_Sound2.png";
import Intro from "./components/Intro"
import UserForm from "./components/UserForm"
import Instructions from "./components/Instructions"
import SceneUI from "./components/SceneUI"
import Scene3D from "./components/Scene3D"

import Score from "./components/Score"
import TopResults from "./components/TopResults"
import useWindowFocused from './components/helpers/useWindowFocused';

export default function App() {

  const isWindowFocused = useWindowFocused();

  const [userID, setUserID] = React.useState(-1);
  const [totalScore, setTotalScore] = React.useState(0);
  const [totalTime, setTotalTime] = React.useState(0);
  const [topScores, setTopScores] = React.useState({});
  const [userScoreUI, setUserScoreUI] = React.useState("0");
  const [userTimeUI, setUserTimeUI] = React.useState("00:00");
  const [userLifesUI, setUserLifesUI] = React.useState("3");
  const [playGame, setPlayGame] = React.useState(false);
  const [isGameLoaded, setIsGameLoaded] = React.useState(false); 
  const [gameOver, setGameOver] = React.useState(false);
  const [soundMuted, setSoundMuted] = React.useState(false);

  const [horizontalMovement, setHorizontalMovement] = React.useState(0);
  const [verticalMovement, setVerticalMovement] = React.useState(0);

  const setLocalUserTime = (value: number) => {
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = Math.floor(value % 60);
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
    setTotalTime(value)
    setUserTimeUI(`${formattedMinutes}:${formattedSeconds}`)
  }

  const setLocalUserScore = (value: number) => {
    setTotalScore(value)
    setUserScoreUI(""+value)
  }

  const setLocalUserLifes = (value: number) => {
    var gameover = value < 1
    setGameOver(gameover)
    setUserLifesUI(""+value)
    if(gameover === true){
      SendForm();
      setTimeout(() => { setPlayGame(false); setLocalView("Score") }, 3000);
    }
  }

  const ResetGame = () => {
    setUserID(-1)
    setTotalScore(0)
    setTotalTime(0)
    setTopScores({})
    setUserScoreUI("0")
    setUserTimeUI("00:00")
    setUserLifesUI("0")
    setPlayGame(false)
    setIsGameLoaded(false)
    setGameOver(false)
  }

  const SendForm = () => {
    if(userID < 0)
      return;
    console.log(userID)
    console.log(totalScore)
    console.log(totalTime)
    fetch('https://x0cv9pf8rj.execute-api.us-east-1.amazonaws.com/api/si-es-ahora/points', {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(
        {
          "user": userID,
          "point": totalScore,
          "time": totalTime
          }
      )
    }
    ).then(response => {
      response.json().then(jSonResponse => {
        if (jSonResponse.statusCode === 200) {
          console.log("Score Form Sent!")
          setTopScores(jSonResponse)
        }
        console.log(jSonResponse)
      })
    }
    )
      .then(responseData => {
        console.log(responseData)
      })
      .catch(error => {
        console.error("Error sending Score Form.")
        console.error(error)
      });
  }

  const setLocalView = (view: string) => {
    var enableIntro = (view === "Intro")
    var enableUserForm = (view === "UserForm")
    var enableInstructions = (view === "Instructions")
    var enableSceneUI = (view === "SceneUI")
    var enableScore = (view === "Score")
    var enableTopResults = (view === "TopResults")

    if(enableIntro === true){
      setIntroActive(true)
      setTimeout(() => { setIntroVisible(true) }, 10);
      setTimeout(() => { ResetGame() }, 600);
    }else{
      setIntroVisible(false)
      setTimeout(() => { setIntroActive(false) }, 500);
    }
    if(enableUserForm === true){
      setUserFormActive(true)
      setTimeout(() => { setUserFormVisible(true) }, 10);
    }else{
      setUserFormVisible(false)
      setTimeout(() => { setUserFormActive(false) }, 500);
    }
    if(enableInstructions === true){
      setInstructionsActive(true)
      setTimeout(() => { setInstructionsVisible(true) }, 10);
    }else{
      setInstructionsVisible(false)
      //setInstructionsActive(false)
      setTimeout(() => { setInstructionsActive(false) }, 500);
    }
    if(enableSceneUI === true){
      setSceneUIActive(true)
      setTimeout(() => { setSceneUIVisible(true); setScene3DVisible(true) }, 10);
    }else{
      setSceneUIVisible(false)
      setScene3DVisible(false)
      setTimeout(() => { setSceneUIActive(false) }, 500);
    }
    if(enableScore === true){
      setScoreActive(true)
      setTimeout(() => { setScoreVisible(true) }, 10);
    }else{
      setScoreVisible(false)
      setTimeout(() => { setScoreActive(false) }, 500);
    }
    if(enableTopResults === true){
      setTopResultsActive(true)
      setTimeout(() => { setTopResultsVisible(true) }, 10);
    }else{
      setTopResultsVisible(false)
      setTimeout(() => { setTopResultsActive(false) }, 500);
    }
  
  };

  const [isIntroVisible, setIntroVisible] = React.useState(true);
  const [isUserFormVisible, setUserFormVisible] = React.useState(false);
  const [isInstructionsVisible, setInstructionsVisible] = React.useState(false);
  const [isSceneUIVisible, setSceneUIVisible] = React.useState(false);
  const [isScoreVisible, setScoreVisible] = React.useState(false);
  const [isTopResultsVisible, setTopResultsVisible] = React.useState(false);
  const [isScene3DVisible, setScene3DVisible] = React.useState(false);

  const [isIntroActive, setIntroActive] = React.useState(true);
  const [isUserFormActive, setUserFormActive] = React.useState(false);
  const [isInstructionsActive, setInstructionsActive] = React.useState(false);
  const [isSceneUIActive, setSceneUIActive] = React.useState(false);
  const [isScoreActive, setScoreActive] = React.useState(false);
  const [isTopResultsActive, setTopResultsActive] = React.useState(false);

  return (
    <div className="full-container-app">
      <div className="full-background-container" style={{ backgroundImage: `url(${background})` }}/>
        <div className="top-background">
          <a className={`top-background-link ${isScene3DVisible ? 'disabled' : ''}`} href='https://www.sistecredito.com/' target='_blank' rel='noreferrer'>
            <img className='sceneui-gameover-icon' src={logoCliente} alt=''/>
          </a>
        </div>
        <div className="views-container">
          {(isIntroActive === true) && <Intro isVisible={isIntroVisible} setView={setLocalView} />}
          {(isUserFormActive === true) && <UserForm isVisible={isUserFormVisible} setView={setLocalView} setUserID={setUserID}/>}
          {(isInstructionsActive === true) && <Instructions isVisible={isInstructionsVisible} setView={setLocalView} isGameLoaded={isGameLoaded} setPlayGame={setPlayGame}/>}
          {(isSceneUIActive === true) && <SceneUI isVisible={isSceneUIVisible} setView={setLocalView} setHorizontalMovement={setHorizontalMovement} setVerticalMovement={setVerticalMovement} userScoreUI={userScoreUI} userTimeUI={userTimeUI} userLifesUI={userLifesUI} gameOver={gameOver}/>}
          {(isScoreActive === true) && <Score isVisible={isScoreVisible} setView={setLocalView} userScoreUI={userScoreUI} userTimeUI={userTimeUI} topScores={topScores}/>}
          {(isTopResultsActive === true) && <TopResults isVisible={isTopResultsVisible} setView={setLocalView} topScores={topScores}/>}
          {(isIntroActive === false) && <Scene3D  isVisible={isScene3DVisible} playGame={playGame} gameOver={gameOver} horizontalMovement={horizontalMovement} verticalMovement={verticalMovement} 
                                                  setHorizontalMovement={setHorizontalMovement} setVerticalMovement={setVerticalMovement} setUserScore={setLocalUserScore} setUserTime={setLocalUserTime} setUserLifes={setLocalUserLifes} setIsGameLoaded={setIsGameLoaded} isWindowFocused={isWindowFocused} soundMuted={soundMuted}/>}
        </div>
        {(isIntroActive === false) && <div className="top-music"><img className='top-music-icon' src={soundMuted ? iconSoundOff : iconSoundON} onClick={() => setSoundMuted(!soundMuted)} alt=''/></div>}
    </div>
  );
}